// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Minus: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="3" viewBox="0 0 11 3">
            <path
                fill="currentColor"
                d="M9,1.5 L0.75,1.5 C0.335390568,1.5 0,1.16437483 0,0.749765754 C0,0.335156679 0.335390568,0 0.75,0 L9,0 C9.41460943,0 9.75,0.335156322 9.75,0.749765754 C9.75,1.16437483 9.41484404,1.5 9,1.5 Z"
                transform="translate(.375 .75)"
            />
        </svg>
    );
};

export default React.memo(Minus);
